import React from 'react';

import { formatUtcDate, isPastDate } from '@utils/dates';

interface SubscriptionExpirationProps {
  paidThroughDate: string;
}

const SubscriptionExpiration = ({ paidThroughDate }: SubscriptionExpirationProps) => {
  const isDateInThePast = isPastDate(paidThroughDate);
  const expiryText = isDateInThePast ? 'expired' : 'expires';

  return (
    <p className="m-0 mt-28 font-suisse-intl text-form text-grayscale-gray">
      Subscription {expiryText}:{' '}
      <span className="text-black">{formatUtcDate(paidThroughDate)}</span>
    </p>
  );
};

export default SubscriptionExpiration;
